import { mapActions } from "vuex";

export default {
    methods: {
        ...mapActions({
            saveAll: 'crudStore/saveAll',
        }),
        async actualizarFtn() {
            try {

            } catch {

            }
        },
        async saveForm(event) {
            try {
                if (event.ftn !== undefined) {
                    switch (event.ftn) {
                        case 'eliminarExamenFtn':
                            await this.updateDataPost({
                                data: {
                                    data: [],
                                    route: 'delete_agenda',
                                    tablaPost: ['info_agendas']
                                }
                            })
                            break;
                        case 'pacienteExamenFtn':
                            await this.updateDataForm({ state: 'info_examens/user_id', data: this.user.id })
                            await this.updateDataPost({
                                data: {
                                    data: [],
                                    route: 'save_examen',
                                    tablaPost: ['datos_pacientes', 'info_examens', 'examen_antecedentes', 'examen_diagnosticos', 'examen_pruebas', 'info_agendas']
                                }
                            })
                            break;
                    }
                }

                await this.save(event.save)

                if (event.ftn !== undefined) {
                    switch (event.ftn) {
                        case 'pacienteExamenFtn':
                            await this.spliceDataGet(this.indexData)
                            break;
                        case 'eliminarExamenFtn':
                            await this.spliceDataGet(this.indexData)
                            break;
                    }
                }

                await this.resetGlobal({ state: 'indexData' })
                await this.resetGlobal({ state: 'openModal' })
                await this.resetDataForm()

                return true
            } catch {

            }
        }
    },
}